import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { SECURITY_MATERIAL_LIST_API } from '../../utils/api';

function SecurityTab({ form, setForm }) {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const customer_id = decoded.customer_id;

  useEffect(() => {
    fetchMaterials();
  }, []);

  const fetchMaterials = async () => {
    try {
      const res = await axios.post(SECURITY_MATERIAL_LIST_API, { token, customer_id });
      if (res.data.success && res.data.materials) {
        const opts = res.data.materials
          .filter(item => item.status === 1)
          .map(item => ({
            value: item.name,
            label: item.name
          }));
        setOptions(opts);

        // If form already has selected items (edit mode), set them in Select
        if (Array.isArray(form.securityItems) && form.securityItems.length > 0) {
          const selected = opts.filter(opt => form.securityItems.find(i => i.name === opt.value));
          setSelectedOptions(selected);
        }
      }
    } catch (err) {
      console.error('Error loading materials:', err);
    }
  };

  const handleSecurityChange = (selected) => {
    setSelectedOptions(selected || []);
    const updated = (selected || []).map(opt => {
      const existing = form.securityItems?.find(i => i.name === opt.value);
      return {
        name: opt.value,
        qty: existing?.qty || ''
      };
    });
    setForm(prev => ({ ...prev, securityItems: updated }));
  };

  const handleQtyChange = (index, value) => {
    const updated = [...form.securityItems];
    updated[index].qty = value;
    setForm(prev => ({ ...prev, securityItems: updated }));
  };

  const handleOtherChange = (e) => {
    setForm(prev => ({ ...prev, issuedOthers: e.target.value }));
  };

  return (
    <>
      <div className="mb-3">
        <label className="form-label">Security Items Issued</label>
        <Select
          isMulti
          options={options}
          value={selectedOptions}
          onChange={handleSecurityChange}
          classNamePrefix="react-select"
          placeholder="Select issued items"
        />
      </div>

      {form.securityItems?.map((item, idx) => (
        <div className="mb-3 row" key={item.name}>
          <div className="col-md-6">
            <label className="form-label">{item.name} Qty</label>
            <input
              type="number"
              className="form-control"
              min="1"
              value={item.qty}
              onChange={(e) => handleQtyChange(idx, e.target.value)}
            />
          </div>
        </div>
      ))}

      <div className="mb-3">
        <label className="form-label">Other Material Details</label>
        <input
          className="form-control"
          name="issuedOthers"
          value={form.issuedOthers || ''}
          onChange={handleOtherChange}
          placeholder="Specify other materials issued"
        />
      </div>
    </>
  );
}

export default SecurityTab;
